import { Notifications } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import InventoryIcon from "@mui/icons-material/Inventory";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PaymentIcon from "@mui/icons-material/Payment";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

function NotificationDrawer(props) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const toggleDrawer = (state) => () => {
    setOpenDrawer(state);
  };

  const notifications = [
    {
      id: 1,
      type: "order",
      title: "New Order Received",
      time: "2 min ago",
      isRead: true,
      icon: <NotificationsIcon color="primary" />,
    },
    {
      id: 2,
      type: "payment",
      title: "Table #5 Bill Paid",
      time: "10 min ago",
      isRead: false,
      icon: <PaymentIcon color="success" />,
    },
    {
      id: 3,
      type: "stock",
      title: "Low Stock Alert: Beer",
      time: "30 min ago",
      isRead: true,
      icon: <InventoryIcon color="warning" />,
    },
  ];

  return (
    <>
      <Tooltip title="Notifications">
        <IconButton
          onClick={toggleDrawer(true)}
          sx={{ p: 1.2, position: "relative" }}
        >
          <Badge badgeContent={3} color="error">
            <Notifications />
          </Badge>
        </IconButton>
      </Tooltip>

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={toggleDrawer(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: 360,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1,
          }}
        >
          <Typography variant="h6">Notifications</Typography>
          <Box>
            <Button size="small">Mark all as read</Button>
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        <Divider />

        {/* Notifications list */}
        <List sx={{ width: "100%", p: 0 }}>
          {notifications.map((n, index) => (
            <Box key={n.id}>
              <ListItem
                alignItems="flex-start"
                sx={{
                  bgcolor: !n.isRead
                    ? "rgba(145, 158, 171, 0.08)"
                    : "transparent",
                  "&:hover": {
                    bgcolor: "rgba(145, 158, 171, 0.16)",
                  },
                }}
              >
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      bgcolor:
                        n.type === "order"
                          ? "primary.light"
                          : n.type === "payment"
                          ? "success.light"
                          : "warning.light",
                    }}
                  >
                    {n.icon}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="body2" fontWeight={500}>
                      {n.title}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      {n.time}
                    </Typography>
                  }
                />
              </ListItem>

              {/* Divider full width including icons */}
              {index < notifications.length - 1 && (
                <Divider sx={{ borderStyle: "dashed" }} />
              )}
            </Box>
          ))}
        </List>
      </Drawer>
    </>
  );
}

export default NotificationDrawer;
